import { render } from "./Page.vue?vue&type=template&id=746826a4&scoped=true"
const script = {}

import "./Page.vue?vue&type=style&index=0&id=746826a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-746826a4"

export default script